import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ToggleFields from '../../components/ToggleFields';

const PPA = ({ control, disabled, setValue }) => {
    const { t } = useTranslation();
    return (
        <ToggleFields
            control={control}
            defaultValue="ppa_price"
            disabled={disabled}
            name="parameters[ppa_type]"
            setValue={setValue}
            values={{
                ppa_price: {
                    append: `$/kWh`,
                    label: `${t('Price') + '/kWh'}`,
                    name: 'parameters[ppa_price]',
                },
                ppa_target_irr: {
                    append: '%',
                    label: t('Target IRR'),
                    name: 'parameters[ppa_target_irr]',
                },
            }}
        />
    );
};

PPA.propTypes = {
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default PPA;
